import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

const Button = (props) => {
  const { className, children, to, href, onClick, variant = 'blue' } = props;

  if (to) {
    return (
      <StyledButton className={className} to={to} variant={variant}>
        {children}
      </StyledButton>
    );
  }

  if (href) {
    return (
      <StyledButton
        className={className}
        href={href}
        as="a"
        target="_blank"
        rel="noreferrer"
        variant={variant}
      >
        {children}
      </StyledButton>
    );
  }

  return (
    <StyledButton
      as="button"
      className={className}
      onClick={onClick}
      variant={variant}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Link)`
  appearance: none;
  padding: 0px 30px;
  height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: none;
  border: ${({ variant }) =>
    variant === 'blue' ? 'none' : '1px solid rgb(62, 170, 240)'};
  background: ${({ variant }) =>
    variant === 'blue' ? 'linear-gradient(#3eaaf0, #057fce)' : 'white'};
  box-shadow: 0px 1px 3px rgba(153, 155, 162, 0.15);
  color: ${({ variant }) =>
    variant === 'blue' ? 'white' : 'rgb(7, 108, 176)'};

  cursor: pointer;
  text-decoration: none;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 4px;
    background: ${({ variant }) =>
      variant === 'blue'
        ? 'linear-gradient(var(--blue-light), rgb(5, 107, 174))'
        : 'rgb(220, 223, 232)'};

    opacity: 0;
    transition: opacity 0.2s ease-out;
    z-index: -1;
  }

  &:hover::before {
    opacity: 1;
  }

  &:focus {
    box-shadow: 0 0 0 4px rgba(5, 127, 206, 0.25);
    outline: none;
  }
`;

export default Button;
